import { SlicePipe } from '@angular/common';
import { Component, ElementRef, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-average-difference-graph',
    templateUrl: './average-difference-graph.component.html',
    styleUrls: ['./average-difference-graph.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AverageDifferenceGraphComponent implements OnInit {

	@ViewChild('barsgraph', { static: true }) divToMeasureElement: ElementRef;

	@Input() showNumber: number;
	@Input() rangeNumber: number = 7;
	@Input() dataType: string;
	@Input() type: string;
	@Input() max: number;
	@Input() heigth: number = 400;
	@Input() list: any = [];
	@Input() xlabelValue: string
	@Input() yObjects: any;
	@Input() overlap: boolean;
	@Input() maxValuesColors: Array<number>; // Only allows 3 values: [0] green, [1] yellow, [2] orange...  >[2] is equal to red
	@Input() differenceBy: number = 5;
	@Input() backTranslateLabel: boolean = false;

	viewBoxwidth: number = 1024;
	viewBoxheigth: number = 500;
	separatorIndex: number = 50;
	viewBoxSize: string = "0 0 1024 500";
	position: number = 0;
	range: any = [];
	numberOfParts: number;
	colorClass: string;

	selectedItem: any;

	zoom(ev) {
		if (ev == 'in') {
			if (this.showNumber > 5) {
				this.showNumber += 5
			} else {
				this.showNumber += 1
			}
			if (this.showNumber > this.list.length) {
				this.showNumber = this.list.length
			}

		} else {
			// showNumber > 5
			if (this.showNumber > 5) {
				this.showNumber -= 5
			} else {
				this.showNumber -= 1
			}
			if (this.showNumber < 1) {
				this.showNumber = 1
			}
		}
		this.position = 0
	}
	next() {
		if (this.showNumber > 5) {
			this.position += 5
		} else {
			this.position += 1
		}

	}
	previous() {
		if (this.showNumber > 5) {
			this.position -= 5
		} else {
			this.position -= 1
		}

		if (this.position < 0) {
			this.position = 0
		}
	}

	nextDetail() {
		if (this.position < this.list.length - this.showNumber) {
			this.next();
		}
		let currentIndex = this.selectedItem.item.index;
		if (this.list[currentIndex + 1]) {
			this.selectedItem = {
				'item': this.list[currentIndex + 1],
				'graph': this.yObjects[0]
			};
		}
	}

	previousDetail() {
		if (this.position > 0) {
			this.previous();
		}
		let currentIndex = this.selectedItem.item.index;
		if (this.list[currentIndex - 1]) {
			this.selectedItem = {
				'item': this.list[currentIndex - 1],
				'graph': this.yObjects[0]
			};
		}
	}

	getSpaceX() {
		return (this.viewBoxwidth - 35 - 24) / (this.showNumber + 1)
	}
	labelPosition(pos) {
		var a = 35 + (this.getSpaceX() * (pos + 1));
		return a
	}
	getBarWidth() {
		var a = this.getSpaceX();
		if (this.overlap) {
			return a * 0.7
		} else {
			return a / (this.yObjects.length + 1) * .8
		}

	}
	getBarX(pos, gPos) {
		var a = this.getSpaceX();
		if (this.overlap) {
			return this.labelPosition(pos) - this.getBarWidth() / 2
		} else {
			return (this.labelPosition(pos) + (this.getBarWidth() * (gPos)) + (a / (this.yObjects.length + 1) * .2 * (gPos + 1))) - (a / 2) - (a / (this.yObjects.length + 1) * .1) + (a / (this.yObjects.length + 1) * 0.5)
		}

	}

	getBarY(item, graph) {
		let y = 0;
		let middle = 10 + (this.separatorIndex * this.numberOfParts);
		if (item[graph.value] <= 0) {
			y = middle;
		} else {
			let value = item[graph.value] > this.max ? this.max : item[graph.value];
			y = middle - (value * middle / this.max);
		}
		return y;
	}

	getBarheight(item, graph) {
		let h = 0;
		// let maxHeight = (this.viewBoxheigth - 10) / 2;
		let maxHeight = (this.viewBoxheigth - 50) / 2;
		h = Math.abs(item[graph.value]) * maxHeight / this.max;

		h = h > maxHeight ? maxHeight : h;
		return h
	}

	getXLabel(item) {
		if (this.xlabelValue) {
			return this.backTranslateLabel ? this._gS.backTranslate(item, this.xlabelValue) : item[this.xlabelValue]
		} else {
			return "--"
		}

	}

	openDetailBar(item, graph) {
		this.selectedItem = {
			'item': item,
			'graph': graph
		};
	}

	getClasses(item, graph, isDetailBox?) {
		let classes = [];

		if (item[graph.value] > 0 && !isDetailBox) {
			classes.push('is-positive')
		}

		if (Math.abs(item[graph.value]) <= this.maxValuesColors[0]) {
			classes.push('is-green');
		} else if (Math.abs(item[graph.value]) <= this.maxValuesColors[1]) {
			classes.push('is-yellow');
		} else if (Math.abs(item[graph.value]) <= this.maxValuesColors[2]) {
			classes.push('is-orange');
		} else if (Math.abs(item[graph.value]) > this.maxValuesColors[2]) {
			classes.push('is-red');
		}
		return classes;
	}

	constructor(public slicePipe: SlicePipe, public _gS: GlobalService) { }

	ngOnChanges(changes: SimpleChanges) {
		if (changes.list) {
			for (let i = 0; i < this.list?.length; i++) {
				this.list[i].index = i;
			}
		}
	}

	ngOnInit() {
		this.range = new Array(this.rangeNumber);
		this.numberOfParts = Math.floor(this.range.length / 2);
		this.viewBoxwidth = this.divToMeasureElement.nativeElement.offsetWidth;
		this.viewBoxheigth = this.heigth;

		if (this.viewBoxheigth < 150) {
			this.viewBoxheigth = 150
		}
		this.viewBoxSize = "0 0 " + this.viewBoxwidth + " " + this.viewBoxheigth;
		// this.separatorIndex = (this.viewBoxheigth - 10) / this.range.length;
		this.separatorIndex = (this.viewBoxheigth - 30) / this.range.length;

	}


}
